import "./src/styles/global.css";
import { wrapWithProviders } from "./src/components/wrap-with-providers";

export const wrapRootElement = wrapWithProviders;
